export default __webpack_public_path__ + "static/BT_Benefits_Carousel_00-55dbda7f1bc874e458629e60c340f713.png";